import type { ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface TextLinkProps {
    href: string
    children: ReactNode
    className?: string
}

/** Quiet secondary link: plain underlined text. */
export const TextLink = ({ href, children, className }: TextLinkProps) => {
    return (
        <Link
            href={href}
            className={cn(
                'text-sm text-cream/80 underline decoration-cream/30 underline-offset-[6px] transition-colors duration-300 hover:text-cream hover:decoration-citron',
                className
            )}
        >
            {children}
        </Link>
    )
}
